import { useState } from "react";
import PropTypes from "prop-types";
import { UilAngleLeft, UilAngleRight } from "@iconscout/react-unicons";
import IconBtn from "../icon-btn";
import Picture from "../picture";
import Slider from "../slick-slider";
import "./gallery-carousel.css";

const NextArrow = ({ className, style, onClick }) => {
  return (
    <IconBtn className={className} style={style} onClick={onClick}>
      <UilAngleRight />
    </IconBtn>
  );
};

const PrevArrow = ({ className, style, onClick }) => {
  return (
    <IconBtn className={className} style={style} onClick={onClick}>
      <UilAngleLeft />
    </IconBtn>
  );
};

const GalleryCarousel = ({ pictures, onClick }) => {
  const count = pictures?.length;
  const [index, setIndex] = useState(0);

  const settings = {
    speed: 500,
    dots: true,
    swipe: false,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (oldIndex, newIndex) => {
      setIndex(newIndex);
    },
    customPaging: (i) => (
      <button style={count > 5 ? { transform: Math.abs(index - i) <= 1 ? "scale(1.33)" : "scale(1)" } : null}>
        {i + 1}
      </button>
    ),
    appendDots: (dots) => (
      <div>
        <ul
          style={{
            display: "flex",
            transform:
              count > 5 ? `translateX(${(count - index < 3 ? count - 5 : index > 2 ? index - 2 : 0) * -12}px)` : null,
          }}
        >
          {dots}
        </ul>
      </div>
    ),
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          swipe: true,
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className="gallery-carousel">
      <Slider {...settings}>
        {pictures
          .filter((t) => !!t.image)
          .map((picture, idx) => (
            <div key={idx} className="px-1">
              <Picture
                width="100%"
                height="100%"
                picture={picture}
                objectFit="cover"
                layout="responsive"
                onClick={() => onClick(picture)}
                className="cursor-pointer rounded"
              />
            </div>
          ))}
      </Slider>
    </div>
  );
};

GalleryCarousel.propTypes = {
  pictures: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      image: PropTypes.shape({}),
      project: PropTypes.shape({
        _id: PropTypes.string,
      }),
    })
  ),
};

export default GalleryCarousel;
